import { Component, OnInit } from '@angular/core';
import { TIMER_EXPIRED } from './core/services/session-time/session-time.constant';
import { SessionTimeService } from './core/services/session-time/session-time.service';
import { BackgroundService } from './core/services/background/background.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private sessionTimeService: SessionTimeService, private backgroundServices: BackgroundService) { }

  ngOnInit(): void {
    this.sessionTimeService.timerExpiredSession().subscribe({
      next: () => {
        if (this.sessionTimeService.calculateTimerFinish() === TIMER_EXPIRED.preexpiredmessage.time) {
          this.sessionTimeService.openNotificationPreExprired();
        }
      },
      error: () => { },
      complete: () => {
        this.sessionTimeService.openNotificationExprired();
      }
    });
  }
}
